type ResourceDetailsProps = {
  isMissingResource: boolean;
  missingResourceTitle: string;
  resourceTitle: string;
};

export const ResourceDetails = ({ isMissingResource, missingResourceTitle, resourceTitle }: ResourceDetailsProps) => {
  if (isMissingResource) {
    return (
      <div className="flex flex-col">
        <span className="text-s-r text-danger-20">{missingResourceTitle}</span>
        <span className="text-s-r text-base-10">{`(${resourceTitle} used as reference)`}</span>
      </div>
    );
  }

  return <span className="text-s-r text-base-10">{resourceTitle}</span>;
};
